import { render, staticRenderFns } from "./ListaPeriodicos.vue?vue&type=template&id=627bda63&scoped=true"
import script from "./ListaPeriodicos.vue?vue&type=script&lang=js"
export * from "./ListaPeriodicos.vue?vue&type=script&lang=js"
import style0 from "./ListaPeriodicos.vue?vue&type=style&index=0&id=627bda63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627bda63",
  null
  
)

export default component.exports